export default __webpack_public_path__ + "static/media/spot-celebrate.5b0d7c02.svg";